<template>
  <nav v-if="items.length" class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumbs__list">
      <li
        v-for="(crumb, index) in items"
        :key="index"
        :class="{
          breadcrumbs__item: true,
          'breadcrumbs__item--active': index === items.length - 1,
        }"
      >
        <component :is="index < items.length - 1 ? 'router-link' : 'div'" :to="crumb.route">
          <span>{{ crumb.name }}</span>
        </component>

        <span v-if="index < items.length - 1" class="breadcrumbs__separator">
          <ChevronRight :size="16" />
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { ChevronRight } from 'lucide-vue'

export default {
  name: 'Breadcrumbs',
  components: {
    ChevronRight,
  },
  metaInfo() {
    return { ...this.metaInfo }
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    metaInfo() {
      if (!this.items.length) {
        return {}
      }

      // https://yandex.ru/support/webmaster/supported-schemas/navigation-links.html
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: this.items.map((item, idx) => ({
                '@type': 'ListItem',
                position: idx + 1,
                item: {
                  '@id': this.$router.resolve(item.route)?.href,
                  name: item.name,
                  url: this.$router.resolve(item.route)?.href,
                },
              })),
            },
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.breadcrumbs {
  font-size: 14px;
  line-height: 16px;
  color: $DGray;

  &__list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style: none;
  }

  &__item {
    display: inline-flex;
    align-items: center;

    > a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: $GreenM;
      }
    }
  }

  &__separator {
    margin: 0 6px;
  }
}
</style>
